export default {
    "cloud": "/api/cloud",
    "app": "/api/app",
    "ac": "/api/ac",
    "auth": "/api/auth"
}